import { useState } from 'react';
import Box from '@mui/material/Box';
import { guideInitials } from '../../utils/guideCardData';
import { cardColors, u } from './cardTokens';

interface GuideCardPhotoProps {
  src?: string | null;
  name: string;
}

/** Guide photo with a branded initials placeholder — never a broken-image icon. */
export function GuideCardPhoto({ src, name }: GuideCardPhotoProps) {
  const [failedSrc, setFailedSrc] = useState<string | null>(null);
  const showPhoto = Boolean(src) && failedSrc !== src;

  return (
    <Box
      sx={{
        position: 'relative',
        flex: 1,
        minHeight: 0,
        borderRadius: u(16),
        overflow: 'hidden',
        bgcolor: cardColors.photoBg,
      }}
    >
      {showPhoto ? (
        <Box
          component="img"
          src={src!}
          alt={`Photo of ${name}`}
          onError={() => setFailedSrc(src!)}
          sx={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            objectPosition: 'center 25%',
            display: 'block',
          }}
        />
      ) : (
        <Box
          role="img"
          aria-label={`${name} — photo not available`}
          data-testid="guide-card-photo-placeholder"
          sx={{
            width: '100%',
            height: '100%',
            display: 'grid',
            placeItems: 'center',
            background: `linear-gradient(150deg, ${cardColors.navy} 0%, ${cardColors.blue} 100%)`,
            color: cardColors.white,
            fontSize: u(68),
            fontWeight: 700,
            letterSpacing: '0.04em',
          }}
        >
          {guideInitials(name)}
        </Box>
      )}
    </Box>
  );
}
